<!--
 * @Author: your name
 * @Date: 2022-03-04 16:41:33
 * @LastEditTime: 2022-03-07 14:53:54
 * @LastEditors: 么东欣
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /bijixia-wx-h5/src/components/select/dateTime.vue
-->
<!--
 * @Author: your name
 * @Date: 2022-03-04 16:41:49
 * @LastEditTime: 2022-03-04 17:55:46
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /bijixia-wx-h5/src/components/select/area.vue
-->
<template>
  <ios-select
    :sourceData="sourceData"
    :level="3"
    :required="required"
    :label="label"
    :placeholder="placeholder"
    :clearable="clearable"
    :readonly="readonly"
    :disabled="disabled"
    :outline="outline"
    :size="size"
    :placeholderColor="placeholderColor"
    :relation="[1, 1]"
    separation="-"
    v-model="value"
    @change="change"
  >
    <template v-slot:suffix>
      <i class="iconfont icon-gengduoyonghu"></i>
    </template>
  </ios-select>
</template>

<script>
import iosSelect from './index.vue'

export default {
  components: {
    iosSelect,
  },
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: [Number, Array, String],
      default: '',
    },
    label: {
      type: String,
      default: '标签',
    }, //label
    placeholder: {
      type: String,
      default: '',
    }, //原生属性
    clearable: {
      type: Boolean,
      default: false,
    }, //Todo...
    disabled: {
      type: Boolean,
      default: false,
    }, //原生属性
    readonly: {
      type: String,
      default: '',
    }, //原生属性，是否只读
    outline: {
      type: Boolean,
      default: false,
    }, //全边框输入框
    size: {
      type: String,
      default: 'middle', //large big middle small xs
    },
    placeholderColor: {
      type: String,
      default: '#979797',
    },
  },
  emits: ['change'],
  data() {
    return {
      sourceData: [],
      value: [],
    }
  },
  watch: {
    modelValue(v) {
      this.init()
	  if(v){
		  this.value = v
	  }
    },
  },
  methods: {
    init() {
      var now = new Date()
      let nowYear = 1922; // 设置开始年份
      let nowMonth = now.getMonth() * 1 + 1
      nowMonth = nowMonth > 9 ? nowMonth : '0' + nowMonth
      let nowDate = now.getDate()
      nowDate = nowDate > 9 ? nowDate : '0' + nowDate
      this.value = [
        { id: 1994, value: 1994 }, // 默认展示年份
        { id: nowMonth, value: nowMonth },
        { id: nowDate, value: nowDate },
      ]
      // 数据初始化
      function formatYear(nowYear) {
        var arr = []
        for (var i = nowYear; i <= now.getFullYear(); i++) {
          arr.push({
            id: i + '',
            value: i,
          })
        }
        return arr
      }
      function formatMonth() {
        var arr = []
        for (var i = 1; i <= 12; i++) {
          arr.push({
            id: i + '',
            value: i,
          })
        }
        return arr
      }
      function formatDate(count) {
        var arr = []
        for (var i = 1; i <= count; i++) {
          arr.push({
            id: i + '',
            value: i,
          })
        }
        return arr
      }
      var yearData = function (callback) {
        callback(formatYear(nowYear))
      }
      var monthData = function (year, callback) {
        callback(formatMonth())
      }
      var dateData = function (year, month, callback) {
        if (/^(1|3|5|7|8|10|12)$/.test(month)) {
          callback(formatDate(31))
        } else if (/^(4|6|9|11)$/.test(month)) {
          callback(formatDate(30))
        } else if (/^2$/.test(month)) {
          if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
            callback(formatDate(29))
          } else {
            callback(formatDate(28))
          }
        } else {
          throw new Error('month is illegal')
        }
      }
      this.sourceData = [yearData, monthData, dateData]
    },
    change(v) {
      v.forEach((it) => {
        if (it.value <= 9) {
          it.value = '0' + it.value
        }
      })
      this.value = v
      this.$emit('change', v)
    },
  },
}
</script>

<style lang="less" scoped>
.iconfont {
  color: #ccc;
}
</style>